export { default as GDMTypography } from './GDMTypography';

export type { GDMTypographyComponent, GDMTypographyProps } from './GDMTypography.type';
